import React from 'react';
import styles from './evos.module.scss';
import Header from '../../components/header/Header';
import Mission from '../../components/mission/Mission';
import Title from '../../components/title/Title';
import TopBanner from '../../components/topBanner/TopBanner';
import Gallery from '../../components/gallery/Gallery';
import Footer from '../../components/footer/Footer';

const Evos = () => {
  return (
    <div className={styles.container}>
      <Header />
      <Title title="Evos" subtitle="BRAND IDENTITY (DIGITAL MEDIA, PRINT)" />
      <TopBanner
        heroImg="/images/evoz_hero.svg"
        mainText="For hot babes, by hot babes"
        subText="Introducing our latest project, evos — a collaborative savings platform. Designed for couples and groups, it simplifies collective goal achievement. Automated transfers from individual accounts to a shared one at regular intervals make saving easier. Explore how our technology fosters financial cooperation and streamlines goal tracking."
        imgOne="/images/evos.svg"
        imgTwo="/images/hoodie.svg"
        pageName="evos"
      />
      <Mission text="Led product strategy, brand design, and full-stack software development for Evos." />
      <TopBanner
        heroImg="/images/Empea.svg"
        mainText="Fintech"
        subText="DreamLabs worked across strategy, design, and engineering to bring Evos from concept to execution. We defined the product direction and core use cases, designed a clear and approachable brand system, and built the platform to support automation, goal tracking, and group transparency. Every decision, from user flows to technical architecture, was focused on making shared saving intuitive, reliable, and easy to maintain over time."
        imgOne="/images/empea_cup.svg"
        imgTwo="/images/empea_cap.svg"
        pageName="evos"
      />
      <div className={styles.evos_cards}>
        <div className={styles.img_container}>
          <img src="/images/evoscard1.svg" alt="image" />
        </div>
        <div className={styles.img_container}>
          <img src="/images/evoscard2.svg" alt="image" />
        </div>
      </div>
      <Gallery
        topImgOne="/images/business_card.svg"
        topImgTwo="/images/empea_gallery.svg"
        bottomImg="/images/evos_p.svg"
        pageName="evos"
      />
      <Footer />
    </div>
  );
};

export default Evos;
